function getOrdinalSuffix(day) {
  if (day >= 11 && day <= 13) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

export function formatDateAndTimeInALuxuryWay(unixTimestamp) {
  const date = new Date(unixTimestamp); // Already in milliseconds - don't multiply by 1000
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Get browser's timezone

  // Formatter for month, day, year, and time components
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    month: "long", // Full month name (e.g., June)
    day: "numeric", // Day of month (e.g., 12)
    year: "numeric", // Year (e.g., 2025)
    hour: "numeric", // Hour (e.g., 6)
    minute: "2-digit", // Minute (e.g., 37)
    hour12: true, // Use 12-hour clock with AM/PM
  });

  // Formatter for timezone name (e.g., Eastern Daylight Time)
  const tzFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    timeZoneName: "long", // Get full timezone name
  });

  // Get formatted parts
  const parts = formatter.formatToParts(date);
  const tzParts = tzFormatter.formatToParts(date);

  // Extract components
  const month = parts.find((p) => p.type === "month").value; // e.g., June
  const day = parts.find((p) => p.type === "day").value; // e.g., 12
  const year = parts.find((p) => p.type === "year").value; // e.g., 2025
  const hour = parts.find((p) => p.type === "hour").value; // e.g., 6
  const minute = parts.find((p) => p.type === "minute").value; // e.g., 37
  const period = parts.find((p) => p.type === "dayPeriod").value; // e.g., PM
  const timeZoneName = tzParts.find((p) => p.type === "timeZoneName").value; // e.g., Eastern Daylight Time

  // Combine into desired format
  return `${month} ${day}${getOrdinalSuffix(
    Number(day)
  )}, ${year}, ${hour}:${minute} ${period}, ${timeZoneName}`;
}
